import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import AdLoader from '../../components/ad-loader/ad-loader'

import Social from '../../components/social/social'
import socialDefaults from '../../components/social/social.defaults'

import SignUp from '../../components/signup/signup'
import signUpDefaults from '../../components/signup/signup.defaults'
import account from '../../core/services/account/account'

const fullHeight = 600
const componentSize = {
  height: '295px',
  width: '300px',
}

const SocialComponent = ({ channels }) => (
  <Social
    channels={channels}
    title={socialDefaults.title}
    subtitle={socialDefaults.subtitle}
  />
)

const SignUpComponent = () => (
  <SignUp
    signedIn={!!account.user}
    images={signUpDefaults.images}
    texts={signUpDefaults.texts}
    ctas={signUpDefaults.ctas}
    links={signUpDefaults.links}
  />
)

export default class AdSlot502 extends PureComponent {
  static propTypes = {
    social: PropTypes.object.isRequired,
  }

  render() {
    const { social } = this.props

    return (
      <AdLoader id={502} height={600}>
        {({ height }) => {
          if (height >= 600) return null

          if (height >= 250) {
            const marginTop = fullHeight / 2 - height + 5
            const random = Math.floor(Math.random() * 2)
            const ComponentList = [
              () => <SocialComponent channels={social.channels} />,
              () => <SignUpComponent />,
            ]
            const RandomComponent = ComponentList[random]

            return (
              <div
                style={{
                  marginTop: `${marginTop}px`,
                  ...componentSize,
                }}
              >
                <RandomComponent />
              </div>
            )
          }

          if (height >= 0 && height <= 100) {
            return (
              <div style={{ position: 'relative' }}>
                <div style={componentSize}>
                  <SocialComponent channels={social.channels} />
                </div>
                <div style={{ ...componentSize, marginTop: '10px' }}>
                  <SignUpComponent />
                </div>
              </div>
            )
          }
        }}
      </AdLoader>
    )
  }
}
